import { View, Text } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as React from 'react';

type MyDebugProps = {
  children?: React.ReactNode;
};

function HelperSetup() {
  const { scene, camera } = useThree();
  React.useEffect(() => {
    const { id, children } = scene;
    console.log(`${id} camera[${camera.id}]: ${camera.name}`);
    for (const child of children) {
      const { id, name, type } = child;
      console.log(`  - [${id}]: ${type}(${name})`);
      // if (child instanceof Camera) {
      //   const { type, visible } = child;
      //   console.log(`    - ${type} ${visible}`);
      //   if (name == 'main') {
      //     scene.add(new CameraHelper(child));
      //   }
      // }
    }
  }, []);
  return <></>;
}

function MyDebug(props: MyDebugProps) {
  const {} = props;
  const ref = React.useRef<HTMLDivElement>(null!);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <View index={1} className="view-1" style={{ flexGrow: 1 }}>
          {/* {children} */}
          <Text name="hello" color="yellow">
            Hello1
          </Text>
          <HelperSetup />
        </View>
        <View index={2} className="view-1" style={{ flexGrow: 1 }}>
          {/* {children} */}
          <Text name="hello" color="yellow">
            Hello2
          </Text>
          <HelperSetup />
        </View>
      </div>
      <Canvas eventSource={ref} className="canvas">
        <View.Port />
        {/* {children} */}
      </Canvas>
    </div>
  );
}

export type Props = {};

// camera.setViewOffset(100, 100, 10, 10, 100, 100);

function App(props: Props) {
  const {} = props;

  return (
    <React.Suspense>
      <MyDebug>
        {/* <Text name="hello" color="yellow">
          Hello3
        </Text> */}
      </MyDebug>
    </React.Suspense>
  );
}

export default React.memo(App);
